import { EmailTextPhrases, EmailTypeEnum } from '@/types/email.types';

export const getReminderWording = (
  emailType: EmailTypeEnum,
  daysToStart: number,
  textPhrase: (key: keyof Omit<EmailTextPhrases, 'subject'>) => string
) => {
  if (emailType === EmailTypeEnum.session_live) {
    return textPhrase('isLive');
  }
  if (emailType === EmailTypeEnum.session_ended) {
    return textPhrase('isEnded');
  }

  if (daysToStart < 1) {
    return `${textPhrase('starting')} ${textPhrase('soon')}`;
  } else if (daysToStart < 2) {
    return `${textPhrase('starting')} ${textPhrase('tomorrow')}`;
  } else {
    return `${textPhrase('startingIn')} ${daysToStart} ${textPhrase('days')}`;
  }
};
